<template>
  <v-dialog persistent v-model="approveModal" width="700">
    <v-card>
      <v-card-title class="headline blue darken-3 white--text" default-title>Approve Trekking Request
      </v-card-title>

      <v-card-text class="px-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 v-if="errors">
              <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                  outlined
                  v-for="(value, key) in errors"
                  :key="key"
              >
                <template v-for="(item, index) in value">{{ item }}</template>
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-form ref="approveForm" v-model="valid" lazy-validation class="pa-2">
                <v-textarea
                    label="Remarks"
                    outlined
                    v-model="approveForm.remarks"
                />
                <multiple-file-upload
                    :required="required"
                    label="Attachements"
                    v-model="approveForm.attachements"
                />

                <v-layout row wrap v-if="parseInt(trekkingData.total_cost) !== 0 && !trekkingData.print_trekking_sticker">
                  <v-flex xs12 sm10>
                    <v-text-field
                        type="number"
                        label="Start sticker number"
                        outlined
                        v-model="startNumber"
                        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                    />
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-btn color="blue darken-3" class="white--text" @click="generate">Generate
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div v-if="trekkingData.trekkers.length">
                  <v-layout row wrap v-for="(trekker,index) in trekkingData.trekkers">
                    <v-flex xs6
                            v-if="((trekkingData.extra && trekkingData.extra[1] &&  (trekkingData.extra[1]['isExpedition']) === 'false') || (trekker.isFree && trekker.isFree === 'false')) && !trekkingData.print_trekking_sticker">
                      <v-text-field
                          outlined
                          :label="trekker.name +' Sticker number'"
                          v-model="trekker.sticker_number"
                          :rules="[rules.required]"
                      />
                    </v-flex>
                    <v-flex xs6
                            v-if="(trekkingData.extra && trekkingData.extra.single) && !trekkingData.print_trekking_sticker">
                      <v-text-field
                          outlined
                          :label="trekker.name +' Sticker number'"
                          v-model="trekker.sticker_number"
                          :rules="[rules.required]"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                          outlined
                          disabled
                          :label="trekker.name +' Permit number'"
                          :value="getPermit(index)"
                      />
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout row wrap v-else>
                  <v-flex xs6>
                    <v-text-field
                        outlined
                        :label="trekkingData.trekkers.name +' Sticker number'"
                        v-model="trekkingData.trekkers.sticker_number"
                        :rules="[rules.required]"
                    />
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                        outlined
                        disabled
                        :label="trekkingData.trekkers.name +' Permit number'"
                        :value="getSinglePermit"
                    />
                  </v-flex>
                </v-layout>

              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            color="red lighten-1"
            class="white--text"
            @click="close"
        >Cancel
        </v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="approve">Approve</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MultipleFileUpload from "../MultipleFileUpload";
import {validationMixin} from "../../mixins/validationMixin";
import moment from "moment";

export default {
  props: {
    'director': Boolean,
    required: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultipleFileUpload
  },
  data: () => ({
    valid: true,
    approveForm: {},
    errors: [],
    loading: false,
    startNumber: 0
  }),
  mixins: [validationMixin],
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData"]),
    approveModal: {
      get() {
        return this.$store.state.TrekkingSingle.approveModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setApproveModal", value);
      }
    },
    getSinglePermit() {
      return this.trekkingData.trekkingRoute.code + (1 + Number(this.trekkingData.last_traveller_count));
    },
  },
  methods: {
    ...mapActions("TrekkingSingle", ["approveRequest", "approveSingleRequest"]),
    close() {
      this.approveModal = false;
      this.approveForm = {};
    },
    getPermit(index) {
      let currentYear = moment().format('YYYY');
      let lastTwoDigitOfCurrentYear = currentYear.substr(-2, 2);
      let PermitPrefix = 'TP' + lastTwoDigitOfCurrentYear;
      let finalPermitNumber = PermitPrefix + (this.trekkingData.last_traveller_count + 1 + index).toString().padStart(6, '0');
      return finalPermitNumber;
      // return this.trekkingData.trekkingRoute.code + (index + 1 + this.trekkingData.last_traveller_count);
    },
    generate() {
      let start = this.startNumber;
      const trekkers = JSON.parse(JSON.stringify(this.trekkingData.trekkers));
      for (let i = 0; i < trekkers.length; i++) {
        if (trekkers[i].isFree === 'false' || this.trekkingData && this.trekkingData.extra.single) {
          trekkers[i].sticker_number = start;
          start++;
        }
      }
      this.trekkingData.trekkers = trekkers;

    },
    approve() {
      if (this.$refs.approveForm.validate()) {
        this.loading = true;
        let formData = new FormData();
        formData.append('remarks', this.approveForm.remarks);
        let attachments = this.approveForm.attachements;
        if (attachments) {
          for (let i = 0; i < attachments.length; i++) {
            formData.append(`files[${i}]`, attachments[i]);
          }
        }
        if (this.single) {
          for (let i = 0; i < this.trekkingData.trekkers.length; i++) {
            let trekker = this.trekkingData.trekkers[i];
            formData.append(`stickers[${i}]`, trekker['sticker_number']);
          }


          this.approveSingleRequest(formData)
              .then(() => {
                this.form = false;
                this.loading = false;
                this.approveModal = false;
                this.$store.commit("Notification/showSuccess", 'Trekking permit approved successfully');
              })
              .catch(error => {
                this.loading = false;
                if (error.response.status == 422) {
                  this.errors = error.response.data.errors;
                }
              });

        } else {

          for (let i = 0; i < this.trekkingData.trekkers.length; i++) {
            let trekker = this.trekkingData.trekkers[i];
            formData.append(`stickers[${i}]`, trekker['sticker_number']);
          }

          this.approveRequest(formData)
              .then(() => {
                this.form = false;
                this.loading = false;
                this.approveModal = false;
                this.$store.commit("Notification/showSuccess", 'Trekking permit approved successfully');
              })
              .catch(error => {
                this.loading = false;
                if (error.response.status == 422) {
                  this.errors = error.response.data.errors;
                }
              });
        }


      }

    },
  },
};
</script>
